// Copyright 1999-2023. Plesk International GmbH. All rights reserved.

import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * `Spinner` component.
 */
const Spinner = _ref => {
  let {
    baseClassName = `${CLS_PREFIX}spinner`,
    className,
    colorAnimation = true,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    className: classNames(baseClassName, className, {
      [`${baseClassName}--color-animation`]: colorAnimation
    }),
    ...props,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("circle", {
      className: `${baseClassName}__path`,
      fill: "none",
      strokeWidth: "6",
      strokeLinecap: "round",
      cx: "24",
      cy: "24",
      r: "21"
    })
  });
};
export default Spinner;